import React, { useEffect, useState } from "react";

const ADMIN_ALLOWED_EMAILS = [
  "jaime.reyesr22@gmail.com",
  "alombera@gocar.auto",
  "roberto.martinez@gocar.auto",
  "wtorres@gocar.auto",
  "rmaldonado@gocar.auto",
  "jos@gocar.auto",
];

const CREAR_USUARIOS_ALLOWED_EMAILS = [
  "jaime.reyesr22@gmail.com",
  "alombera@gocar.auto",
  "roberto.martinez@gocar.auto",
  "wtorres@gocar.auto",
  "rmaldonado@gocar.auto",
  "jos@gocar.auto",
];

const normalizeEmail = (email = "") =>
  String(email || "")
    .trim()
    .toLowerCase();

const getUserEmail = () =>
  normalizeEmail(localStorage.getItem("userEmail") ?? "");

const getUserModules = () => {
  try {
    const rawModules = localStorage.getItem("modulos");

    if (!rawModules) return [];

    const parsedModules = JSON.parse(rawModules);

    if (Array.isArray(parsedModules)) {
      return parsedModules.map((module) => String(module).trim());
    }

    if (typeof parsedModules === "string") {
      try {
        const parsedAgain = JSON.parse(parsedModules);

        if (Array.isArray(parsedAgain)) {
          return parsedAgain.map((module) => String(module).trim());
        }
      } catch (error) {
        return parsedModules
          .split(",")
          .map((module) => module.trim())
          .filter(Boolean);
      }
    }

    return [];
  } catch (error) {
    return [];
  }
};

const Menu = () => {
  const [userModules, setUserModules] = useState(getUserModules());
  const [userEmail, setUserEmail] = useState(getUserEmail());

  const hasModule = (moduleName) =>
    Array.isArray(userModules) &&
    userModules.some((module) => module === moduleName);

  useEffect(() => {
    const refreshUserData = () => {
      setUserModules(getUserModules());
      setUserEmail(getUserEmail());
    };

    window.addEventListener("storage", refreshUserData);
    window.addEventListener("focus", refreshUserData);

    return () => {
      window.removeEventListener("storage", refreshUserData);
      window.removeEventListener("focus", refreshUserData);
    };
  }, []);

  // Estos 5 permisos son independientes del módulo "admin" (ese es para
  // otro tipo de administración) — solo cuentan aquí, uno por uno.
  const puedeVerCatalogoBabilonia = hasModule("babilonia-catalog-admin");
  const puedeVerUsuariosBabilonia = hasModule("babilonia-users-admin");
  const puedeVerCotizadorAgencia = hasModule(
    "babilonia-agencias-cotizador-admin",
  );
  const puedeVerExportSolicitudes = hasModule(
    "babilonia-export-solicitudes",
  );
  const puedeVerVentasNR = hasModule("babilonia-ventas-nr");
  const puedeVerProdeskNR = hasModule("babilonia-prodesk-nr");
  const puedeVerAuditoria = hasModule("babilonia-auditoria-admin");

  const puedeVerAdministracion =
    puedeVerCatalogoBabilonia ||
    puedeVerUsuariosBabilonia ||
    puedeVerCotizadorAgencia ||
    puedeVerExportSolicitudes ||
    puedeVerVentasNR ||
    puedeVerProdeskNR ||
    puedeVerAuditoria;

  const puedeVerAdmin = ADMIN_ALLOWED_EMAILS.includes(userEmail);

  const puedeCrearUsuarios = CREAR_USUARIOS_ALLOWED_EMAILS.includes(userEmail);

  return [
    { text: "BABILONIA", is_header: true },
    {
      path: "/analytics",
      icon: "material-symbols:home",
      text: "INICIO",
      isVisible: hasModule("analytics"),
    },
    {
      path: "/form/crear-venta",
      icon: "ph:stack-duotone",
      text: "VENTAS",
      isVisible: hasModule("form-wizards"),
    },
    //  {
    //   path: "/form/crear-venta-nr",
    //   icon: "ph:stack-duotone",
    //   text: "VENTAS NR",
    //   isVisible: hasModule("form-wizards"),
    // },
    {
      path: "/deals/request",
      icon: "mdi:frequently-asked-questions",
      text: "SOLICITUDES",
      isVisible: hasModule("deals-requests") || hasModule("deals-request"),
    },
    {
      path: "/pos/customer-order-v2",
      icon: "mdi:car",
      text: "INICIAR PROCESO",
      isVisible: hasModule("form-wizards"),
    },
    {
      path: "/rendimiento",
      icon: "ph:stack-duotone",
      text: "RENDIMIENTO",
      isVisible: hasModule("rendimiento"),
    },
    {
      path: "/pages/register",
      icon: "mdi:user",
      text: "REGISTRO",
      isVisible: puedeCrearUsuarios,
    },

    ...(puedeVerAdministracion
      ? [
          {
            text: "ADMINISTRACIÓN",
            is_header: true,
          },
          {
            path: "/babilonia/catalogo-admin",
            icon: "mdi:database-cog",
            text: "CATÁLOGO BABILONIA",
            isVisible: puedeVerCatalogoBabilonia,
          },
          {
            path: "/babilonia/usuarios-admin",
            icon: "mdi:users",
            text: "USUARIOS BABILONIA",
            isVisible: puedeVerUsuariosBabilonia,
          },
          {
            path: "/babilonia/agencias-cotizador-admin",
            icon: "mdi:swap-horizontal",
            text: "COTIZADOR POR AGENCIA",
            isVisible: puedeVerCotizadorAgencia,
          },
          {
            path: "/babilonia/export-solicitudes",
            icon: "mdi:file-excel",
            text: "EXPORTAR SOLICITUDES",
            isVisible: puedeVerExportSolicitudes,
          },
          {
            path: "/form/crear-venta-nr",
            icon: "ph:stack-duotone",
            text: "VENTAS NR",
            isVisible: puedeVerVentasNR,
          },
          {
            path: "/form/prodesk-nr",
            icon: "ph:stack-duotone",
            text: "PRODESK NR",
            isVisible: puedeVerProdeskNR,
          },
          {
            path: "/babilonia/auditoria",
            icon: "mdi:shield-search",
            text: "AUDITORÍA DE USO",
            isVisible: puedeVerAuditoria,
          },
        ]
      : []),

    ...(puedeVerAdmin
      ? [
          {
            text: "FACTURACIÓN",
            is_header: true,
          },
          {
            path: "/facturacion/comparativo",
            icon: "mdi:file-compare",
            text: "COMPARATIVO EXCEL",
            isVisible: true,
          },
          {
            path: "/facturacion/facturas",
            icon: "mdi:file-upload-outline",
            text: "CARGA FACTURAS",
            isVisible: true,
          },
          {
            path: "/facturacion/graficas",
            icon: "ph:chart-bar-duotone",
            text: "OTROS INGRESOS",
            isVisible: true,
          },
        ]
      : []),
  ];
};

export default Menu;